enum TriBoolean {
    UNDETERMINED = -1,
    FALSE = 0,
    TRUE = 1,
}
export default TriBoolean;